import axios from "axios";
import { API_BASE_URL } from "../config/Base_Url_Config";

// <------------ add to cart --------->
export const user_add_to_cart = async (header, data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/cart/add`, data, {
            headers: header
        });

        return response;
    } catch (error) {
        return error;
    }
}

// <------------ add to cart --------->
export const add_to_cart_list = async (header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/cart`, {
            headers: header
        });

        return response;
    } catch (error) {
        return error;
    }
}

// <------------ Remove from cart --------->
export const remove_to_cart_list = async (header) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/cart/clear`, {
            headers: header
        });
        return response.data;
    } catch (error) {
        console.error("Error removing item from cart:", error);
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

// <------------ Remove from cart --------->
export const item_remove_to_cart_list = async (id, header) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/cart/remove/${id}`, {
            headers: header
        });
        return response.data;
    } catch (error) {
        console.error("Error removing item from cart:", error);
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};


// <------------ add to cart --------->
export const user_update_to_cart = async (header, data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update/cart`, data, {
            headers: header
        });

        return response;
    } catch (error) {
        return error;
    }
}

// <------------ Place Order --------->
export const orders_place = async (data,header) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/orders/place`,data, 
            {headers: header}
        );
        return response;
    } catch (error) {
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

// <------------ get Place Order --------->
export const get_orders_list = async (header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/orders`, {
            headers: header
        }
        );
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

// <------------ get Place Order --------->
export const pricing_plan_data = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/pricing-plan-data`);
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

export const add_addresses = async (data, header) => {
    try {
        const formData = new FormData();

        // Append all form fields to FormData
        for (const key in data) {
            formData.append(key, data[key]);
        }

        const response = await axios.post(`${API_BASE_URL}/addresses`, formData, { headers: header });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

// <-------------address/list ------------>
export const get_address = async (header) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/address/list`, { headers: header });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

export const edit_addresses = async (id, formData, header) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/address/update/${id}`, formData, { headers: header });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : { message: "An error occurred" };
    }
};

